export const IpamLookups = {
    // Region APIs
    allRegions: 'api/ipam/lookups/admin/region',
    regionByName: (regionName) => `api/ipam/lookups/admin/region/${regionName}`,
    regionsByProvider: (providerName) => `api/ipam/lookups/admin/provider/${providerName}`,
    createRegion: 'api/ipam/lookups/admin/region',
    updateRegion: (regionId) => `api/ipam/lookups/admin/region/${regionId}`,
    deleteRegion: (regionId) => `api/ipam/lookups/admin/region/${regionId}`,

    // Super-Supernet APIs
    allSuperSupernets: 'api/ipam/lookups/admin/super-supernet',
    superSupernetByContinent: (continentName) => `api/ipam/lookups/admin/super-supernet/continent/${continentName}`,
    superSupernetContinents: 'api/ipam/lookups/admin/super-supernet/pepsico-continents',
    createSuperSupernet: 'api/ipam/lookups/admin/super-supernet',
    updateSuperSupernet: (id) => `api/ipam/lookups/admin/super-supernet/${id}`,
    deleteSuperSupernet: (id) => `api/ipam/lookups/admin/super-supernet/${id}`,

    // Supernet APIs
    supernetByProviderAndRegion: (provider, region) => `api/ipam/lookups/admin/supernet/${provider}/${region}`,
    createSupernet: 'api/ipam/lookups/admin/supernet',
    updateSupernet: (id) => `api/ipam/lookups/admin/supernet/${id}`,
    deleteSupernet: (id) => `api/ipam/lookups/admin/supernet/${id}`,

    // Hub APIs
    hubByRegion: (region) => `api/ipam/lookups/admin/hub/region/${region}`,
    hubByRegionAndProvider: (region, provider) => `api/ipam/lookups/admin/hub/region/${region}/provider/${provider}`,
    searchHubs: (region, provider) =>
        provider ? `api/ipam/lookups/admin/hub/region/${region}/provider/${provider}/search` : `api/ipam/lookups/admin/hub/region/${region}/search`,
    createHub: 'api/ipam/lookups/admin/hub',
    deleteHub: (id) => `api/ipam/lookups/admin/hub/${id}`,

    // Allocation APIs
    allocations: 'api/ipam/lookups/api/allocate',
    createAllocation: 'api/ipam/lookups/api/allocate',
    createAllocationFromCidr: 'api/ipam/lookups/api/allocate/from-cidr',
    updateAllocation: (id) => `api/ipam/lookups/api/allocate/${id}`,
    deleteAllocation: (id) => `api/ipam/lookups/api/allocate/${id}`,
    subnetTypes: 'api/ipam/lookups/subnet-types',

    // Lookup APIs
    filterTypes: 'api/ipam/lookups/filter-types',
    networkRoutability: 'api/ipam/lookups/network-routability',
    statusValues: 'api/ipam/lookups/status',
    regionFilters: (provider) => `api/ipam/lookups/admin/region/filters${provider ? `?provider=${provider}` : ''}`,

    // Search APIs (POST with pagination)
    searchRegions: 'api/ipam/lookups/admin/region/search',
    searchSuperSupernets: 'api/ipam/lookups/admin/super-supernet/search',
    searchSupernets: (provider, region) => `api/ipam/lookups/admin/supernet/${provider}/${region}/search`,
    searchAllocations: 'api/ipam/lookups/api/allocate/search',

    // Allocation Dashboard APIs
    allocationDashboardStatus: 'api/ipam/lookups/api/allocate/dashboard/status',
    allocationDashboardProvider: 'api/ipam/lookups/api/allocate/dashboard/provider',
    allocationDashboardCidrType: 'api/ipam/lookups/api/allocate/dashboard/cidr-type',
    allocationDashboardRegion: 'api/ipam/lookups/api/allocate/dashboard/region',
    exportAllocations: 'api/ipam/lookups/api/allocate/export',
};

export default IpamLookups;
